var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "z-list-item",
    {
      staticClass: "z-filelist-item",
      class: {
        "z-filelist-item--with-icon": _vm.icon || this.$slots["icon"],
      },
    },
    [
      _c("div", { staticClass: "z-filelist-item__body" }, [
        _vm.icon || this.$slots["icon"]
          ? _c(
              "div",
              { staticClass: "z-filelist-item__icon" },
              [
                _vm.icon
                  ? _c("z-icon", {
                      attrs: { name: _vm.icon, width: "48", height: "48" },
                    })
                  : _vm._t("icon"),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "z-filelist-item__content" }, [
          _c(
            "div",
            { staticClass: "z-filelist-item__slot" },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "u-flex--row z-filelist-item__info" }, [
            _vm.info
              ? _c("span", {
                  staticClass: "z-filelist-item__info-size",
                  domProps: { innerHTML: _vm._s(_vm.info) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.date
              ? _c("span", { staticClass: "z-filelist-item__info-divider" }, [
                  _vm._v("–"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.date
              ? _c("span", { staticClass: "z-filelist-item__info-date" }, [
                  _vm._v(_vm._s(_vm.buildDate(_vm.date))),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }